export default {
  methods: {
    async initModiface () {
      if (process.env.IS_ELECTRON && await !this.$store.getters['SDK/getStatus']) {
        await this.$sdk.setBrandId().then(ans => {
          this.$logs.info(`MODIFACE: INIT: brandId: ${ans.data.brandId}`)
          return this.$sdk.setCountryCode()
        }).then(async ans => {
          this.$logs.info(`MODIFACE: INIT: countryCode: ${ans.data.countryCode}`)
          await this.$sdk.downloadUpdate().catch(err => {
            this.$logs.info(`ERROR: SDK: DOWNLOAD UPDATE: fail`, err)
          })
          return this.$sdk.getUpcs()
        }).then(ans => {
          console.log(`MODIFACE: INIT: getUpc:`, ans.data)
          this.setStatus(true)
          return this.$store.dispatch('SDK/setUpcs', ans.data.data)
        }).catch(err => {
          this.$logs.info(`ERROR: SDK: INIT: fail`)
          this.$logs.info(err)
        })
      }
    },
    checkStatus () {
      return this.getStatus().then(ans => {
        return this.setStatus(true)
      }).catch(err => {
        console.log(err)
        return this.setStatus(false)
      })
    },
    getStatus () {
      return this.$sdk.getStatus()
    },
    getUpcs (upcs) {
      if (process.env.IS_ELECTRON) {
        return this.$sdk.hasUpc(upcs)
      }
      return false
    },
    setStatus (available) {
      return this.$store.dispatch('SDK/setStatus', available).then(ans => {
        this.$logs.info(`SDK: STATUS: ${available} set`)
      })
    }
  }
}
